import { useId } from "react";
import Icon from "../../core/Icon/Icon";
import styles from "./Search.module.scss";

interface SearchProps {
  value: string;
  onChange: (value: string) => void;
}

const Search = ({ value, onChange }: SearchProps) => {
  const id = useId();

  return (
    <div className={styles.search}>
      <input
        id={id}
        name={id}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={styles.input}
      />
      <Icon icon="search" className={styles.icon} />
    </div>
  );
};

export default Search;
